import React, { useState, useEffect } from "react";

import Table from "@mui/material/Table";
import { API } from "aws-amplify";
import config from "../config/aws-exports";
import { Constants } from "../config/Constants";
import Modal from "@mui/material/Modal";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";

import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import BackDrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";

import { useSelector } from "react-redux";
import { authData } from "../redux/auth/authSlice";

// Local imports

//style impoprts
import Fp from "../components/pages/Report/FeedbackPopUp.module.scss";
import FeedbackPopUp from "../components/pages/Report/FeedbackPopUp";
// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: "flex",
//     heigth: "100%",
//     alignItems: "center",
//     justifyContent: "center",
//     background: "transparent",
//   },
//   backdrop: { zIndex: theme.zIndex.drawer + 1, color: "#fff" },
// }));

const header = {
  color: "white",
  fontSize: "16px",
  fontWeight: "400px",
};

const UsersFeedback = () => {
  //const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [feedbackDetails, setFeedbackDetails] = useState([]);
  const [spin, setSpin] = useState(false);
  const [feedback, setFeedback] = useState({});
  const [openFeedback, setOpenFeedback] = useState(false);

  let userDetails = useSelector(authData);
  console.log(userDetails);

  useEffect(() => {
    getFeedbackDetails();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getFeedbackDetails(item) {
    setSpin(true);
    const bodyParam = {
      body: {
        sid: userDetails?.params?.row?.sid,
        schema: "uspsm",
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_FEEDBACK_DETAILS,
        bodyParam,
      );
      setFeedbackDetails(response.body);
      console.log(response);
      setSpin(false);
    } catch (error) {
      console.error(error);
      setSpin(false);
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFeedbackOpen = (feedback) => {
    setOpenFeedback(true);
    setFeedback(feedback);
  };
  const handleFeedbackClose = () => {
    setOpenFeedback(false);
  };

  return (
    <div className={Fp.feedbackmaincontainer}>
      <Dialog
        open={openFeedback}
        aria-labelledby="responsive-dialog-title"
        scroll="paper"
        maxWidth="lg"
      ></Dialog>
      <Modal
        style={{ width: "70%", marginLeft: "15%", marginTop: "2%" }}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={Fp.modal}
        open={openFeedback}
        BackdropProps={{
          timeout: 500,
        }}
      >

            <FeedbackPopUp
              openFeedback={openFeedback}
              handleRegClose={handleFeedbackClose}
              feedback={feedback}
            />

      </Modal>
    
      <BackDrop sx={{ color: "#fff" }} open={spin} className={Fp.backdrop}>
        <CircularProgress color="inherit" />
      </BackDrop>
      <div className={Fp.topbar}>
        <h3 className={Fp.header}>Total Feedback</h3>
      </div>
      <Table>
        <TableHead sx={{ background: "#285780" }}>
          <TableRow>
            <TableCell style={header}> Name</TableCell>
            <TableCell style={header}>Feedback Description</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {(rowsPerPage > 0
            ? feedbackDetails.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
              )
            : feedbackDetails
          )?.map((item) => {
            return (
              <TableRow>
                <TableCell
                  style={{ textTransform: "capitalize", cursor: "pointer" }}
                  onClick={() => handleFeedbackOpen(item)}
                >
                  {item?.fullname?.firstname + " " + item?.fullname?.lastname}
                </TableCell>
                <TableCell>{item?.description}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
              count={feedbackDetails.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </div>
  );
};

export default UsersFeedback;
